import { usePricing } from 'pages/queries/pricing.queries';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Badge from '../Badge';

interface PremiumBadgeProps {
  active?: boolean;
  className?: string;
}

const StyledSpan = styled.span`
  text-decoration: line-through;
  padding-left: 2px;
  padding-right: 2px;
`;

const PremiumBadge: React.FC<PremiumBadgeProps> = ({ active = false, className }) => {
  const { data: pricing } = usePricing();
  const { t } = useTranslation();
  const premiumBadge = React.useMemo(() => {
    const { currency, billingConstants } = pricing || {};
    const { priority, discountedPriority } = billingConstants?.charges.service || {};

    if (discountedPriority !== undefined) {
      const content = (
        <>
          <StyledSpan>
            {currency} {priority}
          </StyledSpan>
          {t('newOrderPage.premiumSlotFees', { currency, price: discountedPriority })}
        </>
      );
      return <Badge content={content} active={active} varient="info" className={className} />;
    }
    return <Badge content={t('newOrderPage.premiumSlotFees', { currency, price: priority })} className={className} />;
  }, [pricing, t, active, className]);

  return premiumBadge;
};

export default PremiumBadge;
